import { addDisplayName, addProps, addState, flowMax } from 'ad-hok'
import {
  addEffectOnMount,
  branchIfFailsPredicate,
  getContextHelpersFromInitialValues,
} from 'ad-hok-utils'
import { FC } from 'react'
import { DataLoading, hasData } from 'shared/src/utils/dataLoading'

interface LoadingContext {
  hasShownInitialLoad: boolean
}

export const [addLoadingContextProvider, addLoadingContext] =
  getContextHelpersFromInitialValues<LoadingContext>({
    hasShownInitialLoad: false,
  })

type ExtractDataLoadingFieldData<TDataLoading> =
  TDataLoading extends DataLoading<infer TData> ? TData : never

export type AddLoadingAndErrorIndicators = <
  TProps extends {},
  TPropName extends keyof TProps
>(
  propName: TPropName,
  options?: { redirectTo404IfError?: boolean }
) => (props: TProps) => Omit<TProps, TPropName> & {
  [propName in TPropName]: ExtractDataLoadingFieldData<TProps[propName]>
}

export const LoadingProvider: FC = flowMax(
  addDisplayName('LoadingProvider'),
  addState('hasShownInitialLoad', 'setHasShownInitialLoad', false),
  addEffectOnMount(({ setHasShownInitialLoad }) => () => {
    setHasShownInitialLoad(true)
  }),
  addLoadingContextProvider,
  ({ children }) => <>{children}</>
)

export type BranchUnlessDataIsPresent = <
  TProps extends {},
  TPropName extends keyof TProps
>(
  propName: TPropName
) => (props: TProps) => TProps & {
  [propName in TPropName]: ExtractDataLoadingFieldData<TProps[propName]>
}

export const branchUnlessDataIsPresent: BranchUnlessDataIsPresent = (
  propName
) =>
  flowMax(
    (branchIfFailsPredicate as any)(propName, hasData as any),
    addProps(({ [propName]: dataLoading }) => ({
      [propName]: (dataLoading as any)['data'],
    }))
  ) as any
